var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSickDay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "200px",
    width: "200px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-153.6 -153.6 819.20 819.20",
    xmlSpace: "preserve",
    fill: "#7a4343",
    stroke: "#7a4343",
    strokeWidth: 3.072,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0,
    transform: "translate(0,0), scale(1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -153.6,
    y: -153.6,
    width: 819.2,
    height: 819.2,
    rx: 0,
    fill: "#e9d2d2",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#CCCCCC",
    strokeWidth: 4.096
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#7a4343;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "61.549,168.34 0,168.34 0,487.291 61.549,487.291 61.549,420.143 450.442,420.143 450.442,487.291 511.992,487.291 511.992,420.143 512,420.143 512,347.397 61.549,347.397 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M459.656,226.389H237.82v87.434H512v-35.09C512,249.824,488.566,226.389,459.656,226.389z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.656,124.07c27.434,0,49.68-22.246,49.68-49.681c0-27.434-22.246-49.68-49.68-49.68 c-27.443,0-49.681,22.246-49.681,49.68C74.975,101.824,97.213,124.07,124.656,124.07z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.213,149.619c-4.66-2.229-9.819-3.59-15.336-3.59h-6.082c-19.688,0-35.639,15.951-35.639,35.622v82.82 c0,27.262,22.091,49.344,49.344,49.344h76.378V234.84h-48.361v-31.221l15.688,7.672c7.262,3.573,15.148,5.328,22.951,5.328 c10.795,0,21.532-3.361,30.574-9.885l40.656-33.68c7.008-5.065,8.574-14.869,3.516-21.869c-5.066-7.025-14.852-8.59-21.869-3.533 l-44.934,27.722c-2.369,1.705-5.148,2.557-7.942,2.565c-2.033,0-4.049-0.451-5.951-1.376l-51.565-26.418 C141.205,149.93,140.68,149.807,140.213,149.619z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "307.754,102.077 295.066,95.324 270.131,142.233 282.82,148.987 "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSickDay);
export default __webpack_public_path__ + "static/media/SickDay.f316e508e793d26399204381da767cb7.svg";
export { ForwardRef as ReactComponent };